var StateData = React.createContext({});
export var StateDataProvider = StateData.Provider;
export var StateDataConsumer = StateData.Consumer;
export default StateData;